import React from 'react';
import { Link } from 'react-router-dom';
import { CornerDecoration } from '@components/common';
import '@styles/placeholder.css';
import './NotFoundPage.css';

const NotFoundPage: React.FC = () => {
  return (
    <section className="page-section placeholder-section">
      <div className="placeholder-container">
        <h1 className="placeholder-title not-found-title">404</h1>

        <div className="placeholder-icon">
          <span className="icon-symbol">👻</span>
        </div>

        <p className="placeholder-description">
          This page has vanished into the void.
          The spirits could not find what you seek.
        </p>

        <nav className="nav-links">
          <Link to="/" className="nav-link">Return Home</Link>
          <Link to="/donate" className="nav-link">Donate</Link>
        </nav>
      </div>

      <CornerDecoration />
    </section>
  );
};

export default NotFoundPage;
